/**
 * Created by superman on 17/2/16.
 * http配置
 */

import axios from 'axios'
import store from './store'
import router from '@/router'
axios.interceptors.request.use(
  (config) => {
    if (store.state.token) {
      // 云端请求通讯录 用的是accessToken
      config.headers.Authorization = `token ${store.state.token}`
      config.headers.token = config?.data?.accessToken || process.env.VUE_APP_no_token
    }
    return config
  },
  (err) => {
    console.log(1111)
    return Promise.reject(err)
  },
)

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          // 只有在当前路由不是登录页面才跳转
          sessionStorage.removeItem('mcutoken')
          store.state.token = null
          sessionStorage.removeItem('mcuuser')
          store.state.user = null
          sessionStorage.removeItem('mcuroot')
          store.state.root = null
          router.currentRoute.path !== 'login' &&
            router.replace({
              path: '/login',
              query: { redirect: router.currentRoute.path },
            })
      }
    }
    console.log(2222)
    return Promise.reject(error.response.data)
  },
)

export default axios
